/**
 */
// 设置语言
// 参考链接如下 https://github.com/alibaba/formily/blob/master/packages/validator/src/locale.ts
// https://formilyjs.org/zh-CN/guide/advanced/validate
// https://core.formilyjs.org/zh-CN/api/entry/form-validator-registry#registervalidatelocale
import langLocal from './validate-locale';
import lang from '@formily/validator/lib/locale.js';
import { registerValidateLocale, setValidateLanguage } from '@formily/core';
export const FORMILY_LANG_MAP = {
  'en-US': lang['en-US'],
  'es-MX': langLocal['es-MX'], // 这种语言暂时没有 自己项目添加
  'zh-CN': lang['zh-CN'],
  'pt-BR': langLocal['pt-BR'], // 这种语言暂时没有 自己项目添加
  'ja-JP': lang['ja'],
};

export default function initFormilyI18n(curLan) {
  // 设置语言
  setValidateLanguage(curLan);
  registerValidateLocale({ [curLan]: { ...FORMILY_LANG_MAP[curLan] } });
}
